export default "__VITE_PUBLIC_ASSET__e554bafb__"